const MB = 1024 * 1024;
const IMAGE_EXT = new Set(['jpg', 'jpeg', 'png', 'webp']);
const IMAGE_MIME = new Set(['image/jpeg', 'image/jpg', 'image/png', 'image/webp']);
const DOC_EXT = new Set(['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt']);
const VIDEO_EXT = new Set(['mp4', '3gp', '3gpp', 'mov', 'webm']);

function extensionOf(filename) {
  const name = String(filename || '');
  const dot = name.lastIndexOf('.');
  if (dot < 0 || dot === name.length - 1) return '';
  return name.slice(dot + 1).toLowerCase();
}

function sizeMessage(kind) {
  if (kind === 'image') return 'Images must be JPEG, PNG, or WEBP and under 5 MB.';
  if (kind === 'document') return 'Documents must be PDF, Word, Excel, PowerPoint, or text and under 100 MB.';
  return 'Audio and video must be under 16 MB.';
}

export function inspectAttachment({ filename, mimeType, size } = {}) {
  const ext = extensionOf(filename);
  const mime = String(mimeType || '').toLowerCase();
  let kind = null;
  let maxBytes = 0;

  const imageByExt = IMAGE_EXT.has(ext);
  const imageByMime = IMAGE_MIME.has(mime);
  if (imageByExt || imageByMime) {
    if (mime.startsWith('image/') && !imageByMime && !imageByExt) {
      return { ok: false, code: 'UNSUPPORTED_MEDIA', message: 'Images must be JPEG, PNG, or WEBP.' };
    }
    kind = 'image';
    maxBytes = 5 * MB;
  } else if (
    ext === 'ogg'
    || ext === 'opus'
    || mime.includes('ogg')
    || mime.includes('opus')
    || mime.startsWith('audio/')
  ) {
    const voice = ext === 'ogg' || ext === 'opus' || mime.includes('ogg') || mime.includes('opus');
    kind = voice ? 'voice' : 'audio';
    maxBytes = 16 * MB;
  } else if (mime.startsWith('video/') || VIDEO_EXT.has(ext)) {
    kind = 'video';
    maxBytes = 16 * MB;
  } else if (DOC_EXT.has(ext)) {
    kind = 'document';
    maxBytes = 100 * MB;
  } else {
    return {
      ok: false,
      code: 'UNSUPPORTED_MEDIA',
      message: 'This file type cannot be sent on WhatsApp. Use a photo, video, audio, or a PDF, Word, Excel, PowerPoint, or text file.',
    };
  }

  if (Number(size) > maxBytes) {
    return { ok: false, code: 'FILE_TOO_LARGE', message: sizeMessage(kind), kind, maxBytes };
  }
  return { ok: true, kind, maxBytes, voice: kind === 'voice' };
}

export function formatBytes(size) {
  const n = Number(size) || 0;
  if (n < 1024) return `${n} B`;
  if (n < MB) return `${Math.round(n / 1024)} KB`;
  return `${(n / MB).toFixed(n >= 10 * MB ? 0 : 1)} MB`;
}

export function isVoiceMedia(media) {
  const name = String(media?.filename || '');
  const mime = String(media?.mime_type || '');
  return /\.ogg$/i.test(name) || /ogg|opus/i.test(mime);
}

export const ATTACH_ACCEPT = {
  document: '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt',
  media: 'image/jpeg,image/png,image/webp,video/*',
  camera: 'image/jpeg,image/png,image/webp',
  audio: 'audio/*,.ogg,.opus',
};
